import { FormInputContainer } from '@strata/react-form-input-container';
import { TextInputFormik } from '@strata/react-inputs';
import { validationStrings } from '@strata/strata-ui-strings';
import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import * as Yup from 'yup';

import { AutomationRule, AutomationRuleFormContext } from 'services/AutomationRuleHelpers';

interface NameSectionProps {
    userCanEdit: boolean;
    formatRuleName: (
        criteria: AutomationRuleFormContext['criteria'],
        action: AutomationRuleFormContext['action'],
    ) => string;
}

export const NameSection = ({ userCanEdit, formatRuleName }: NameSectionProps) => {
    const { values, setFieldValue } = useFormikContext<AutomationRuleFormContext>();
    const { criteria, action } = values;
    useEffect(() => {
        (async () => {
            await setFieldValue('description', formatRuleName(criteria, action));
        })();
    }, [criteria, action, setFieldValue, formatRuleName]);
    return (
        <FormInputContainer>
            <div className="sds_automation-template__row">
                <div className="sds_automation-template__label sds_label font-bold--uppercase">
                    Name
                </div>
                <div style={{ gridColumnStart: 2, gridColumnEnd: 5 }}>
                    <TextInputFormik
                        id="description"
                        placeholderText="Rule Name"
                        disabled={!userCanEdit}
                        required
                        verticalSpacingSmall
                    />
                </div>
            </div>
        </FormInputContainer>
    );
};

NameSection.initialValues = (rule?: Partial<AutomationRule>) => ({
    description: rule?.description ?? '',
});

NameSection.validationSchema = {
    description: Yup.string().required(validationStrings.requiredField.errorMessage),
};

NameSection.submitValues = (values: AutomationRuleFormContext) => ({
    description: values.description,
});

NameSection.duplicateValues = (values: AutomationRuleFormContext) =>
    NameSection.submitValues(values);
